$(document).ready(function(){
  $(document).on('click', '.collection-page__sidebar .sidebar__block-heading', function(){
    if(window.matchMedia("(max-width: 767px)").matches){
      $(this).siblings('.sidebar__block-content').slideToggle();
      $(this).toggleClass('active');
      $(this).parents('.sidebar__block').siblings().find('.sidebar__block-content').slideUp();
      $(this).parents('.sidebar__block').siblings().find('.sidebar__block-heading').removeClass('active');
    }
  });

  var owl = $('.press-gallery');
    owl.owlCarousel({
      loop: false,
      nav: true,
      margin: 10,
      dots:false,
      autoHeight: true,
      items: 1
    });


 
        $('.article-slider').owlCarousel({
          loop: false,
          nav: true,
          margin: 10,
          responsive: {
            0: {
              items: 1
            },
            800: {
              items:2
            },
            960: {
              items: 2
            },
            1200: {
              items:3
            }
          }
      });

   $(".testimonial_slider_wrapper").owlCarousel({
       margin: 20,
       loop: false,
       autoplay: false,
       dots: false,
       autoplayTimeout: 4000,
       autoplayHoverPause: true,
       responsive: {
         0:{
           items:1,
           nav: false,
         },
         600:{
           items:1,
           nav: false
         },
         1000:{
           items:1,
           nav: true
         }
       }
     });


    $('.logo_slider').owlCarousel({
      loop: false,
      nav: true,
      margin: 10,
      responsive: {
        0: {
          items: 1
        },
        800: {
          items: 2
        },
        960: {
          items: 3
        },
        1200: {
          items:4
        }
      }
    });

  $('.hero-gallery').owlCarousel({
    stagePadding: 50,
    loop:true,
    margin:20,
    center: true,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:2
        },
        767:{
            items:2,
            stagePadding: 100,
        },
        1000:{
            items:5
        }
    }
})

  $('.itgv--new-campaigns .site-header__outer-wrapper').removeClass('site-header__outer-wrapper--transparent');

  
});

$(document).ready(function(){
    if (window.location.href === "https://announcement.thesatanictemple.com/rrr-campaign41280784") {
        window.location.replace("https://thesatanictemple.com/pages/rrr-campaigns");
    }
});